export enum Role {
  Admin = 'Admin',
  Regular = 'Regular',
  Manager = 'Manager',
  Viewer = 'Viewer',
}
